import * as React from 'react';
const MarkOnlineImage = () => (
  <svg width={202} height={179} fill="none">
    <path
      d="M30.714 170.263v2.957L2.051 156.681a2.07 2.07 0 0 1-1.044-1.762H1l.03-2.649a2.068 2.068 0 0 0 1.018 1.455l28.663 16.538h.003Z"
      fill="#0088FE"
    />
    <path
      d="M32.778 171.452v2.96l-2.062-1.188v-2.96l2.062 1.188Zm46.784-14.96-35.975 20.861a5.687 5.687 0 0 1-5.697.006l-2.37-1.365v-2.956l2.37 1.365c2.533 1.461 3.167 1.461 5.697-.007l35.975-20.865a1.95 1.95 0 0 0 .975-1.488v2.266c.076.731-.247 1.759-.975 2.183Z"
      fill="#0F6FCE"
    />
    <path d="M35.518 173.036v2.957l-2.74-1.582v-2.96l2.74 1.585Z" fill="#0088FE" />
    <path
      d="M57.162 57.951v7.292c0 .83.44 1.598 1.158 2.019l14.65 8.543m77.261 5.631-35.669 20.607m35.669-20.607 23.551 13.445a4.006 4.006 0 0 0 4.025-.03l3.648-2.156a2 2 0 0 0 .984-1.722V87.36m-49.298-30.827c.003.13 0 3.908 0 5.86 0 .711-.381 1.368-.995 1.725l-3.957 2.306a1.335 1.335 0 0 0 .006 2.31l22.032 12.698m-60.312 42.461-35.542 20.814"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M100.843 64.043 39.871 94.495c-1.571.915-1.571 3.214 0 4.132l91.468 52.915c2.963 1.796 4.839 1.919 8.26-.04l53.98-30.806c3.42-1.962 2.209-4.879-.084-6.341l-87.649-50.312a4.967 4.967 0 0 0-5.003 0Z"
      fill="#101841"
      stroke="#101841"
      strokeWidth={0.334}
      strokeMiterlimit={10}
    />
    <path
      d="m122.856 143.792 54.163-31.163 11.347.167.033 2.106a3.338 3.338 0 0 1-1.675 2.91l-54.591 31.246a5.008 5.008 0 0 1-5.026-.02l-4.251-2.493"
      fill="#0F6FCE"
    />
    <path
      d="m122.853 146.546-3.444-1.966-2.837-1.618-77.548-44.643a3.34 3.34 0 0 1-1.675-2.893v-2.2l4.379 3.795 74.848 43.177 2.836 1.622 3.444 1.973"
      fill="#0088FE"
    />
    <path d="M119.407 141.821v2.76l-2.837-1.619v-2.763l2.837 1.622Z" fill="#0F6FCE" />
    <path
      d="m188.366 112.937-11.347-.166-53.986 31.009-3.508-2.009-2.85-1.628-74.868-43.134-4.462-3.638v2.2a3.34 3.34 0 0 0 1.675 2.893l77.552 44.642 2.836 1.619 3.444 1.965 4.252 2.493a5.001 5.001 0 0 0 5.026.02l54.591-31.246a3.343 3.343 0 0 0 1.675-2.91l-.033-2.106.003-.004Z"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M93.482 59.7 38.587 91.112c-1.568.901-1.772 2.877 0 4.065l88.494 50.976a5.012 5.012 0 0 0 4.989.007l55.215-31.554c1.458-.837 1.462-2.943 0-3.781L98.468 59.701a5.006 5.006 0 0 0-4.99 0h.004Z"
      fill="#fff"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M93.96 63.064 44.258 91.491c-1.275.73-1.275 2.57 0 3.304l83.318 47.993c1.255.724 2.8.724 4.055.003l49.962-28.543c1.188-.681 1.188-2.393 0-3.074l-83.575-48.11a4.071 4.071 0 0 0-4.055 0h-.003Z"
      fill="#fff"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M115.815 97.73c-1.896 1.064-1.913 3.784-.034 4.871l26.461 15.228a6.076 6.076 0 0 0 6.264-.103c1.562-.975 1.526-3.264-.073-4.185l-27.536-15.782a5.14 5.14 0 0 0-5.082-.033v.003Zm-13.684 7.675c-1.896 1.064-1.912 3.784-.033 4.872l26.671 15.312a6.074 6.074 0 0 0 6.264-.104c1.562-.974 1.525-3.264-.074-4.185l-27.745-15.865a5.14 5.14 0 0 0-5.083-.033v.003Z"
      fill="#E5E7EA"
      stroke="#101841"
      strokeWidth={0.334}
      strokeMiterlimit={10}
    />
    <path
      d="M114.28 90.781 90.642 104.34a5.548 5.548 0 0 1-5.57-.003L65.594 93.01c-1.275-.74-1.272-2.583.007-3.32l24.362-14.047a4.424 4.424 0 0 1 4.438.017l19.893 11.597c1.345.79 1.342 2.74-.01 3.52l-.003.004Z"
      fill="#fff"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M101.995 84.646v2.423h-.007c-.05.965-.714 1.919-1.989 2.65-2.656 1.535-6.965 1.535-9.621 0-1.305-.754-1.972-1.739-1.992-2.727v-2.449l1.405.01 10.902.083 1.298.01h.004Z"
      fill="#0087FF"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M95.186 88.602c3.758 0 6.805-1.759 6.805-3.928 0-2.17-3.047-3.928-6.805-3.928-3.758 0-6.804 1.759-6.804 3.928 0 2.17 3.046 3.928 6.804 3.928Z"
      fill="#fff"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m71.311 90.73.06-1.855 15.799 7.706 3.24-3.314c.59-.007 1.011-.01 1.011-.01v3.394a.782.782 0 0 1-.013.08c-.214 1.408-1.158 2.786-2.837 3.927a1.242 1.242 0 0 1-1.325.054l-15.53-9.24a.825.825 0 0 1-.404-.741Z"
      fill="#0087FF"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m87.252 98.443-15.565-8.986a.627.627 0 0 1 .047-1.112c4.776-2.192 11.747-2.016 16.162.537 4.512 2.607 4.739 6.751.674 9.511a1.245 1.245 0 0 1-1.318.05Z"
      fill="#fff"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M165.136 107.817a2.812 2.812 0 0 0-1.365-1.882l-19.108-10.966a7.079 7.079 0 0 0-3.544-.95c-1.225 0-2.39.3-3.464.904a3.336 3.336 0 0 0-1.712 2.65c-.244-1.336.317-2.797 1.668-3.551a7.061 7.061 0 0 1 3.461-.905 7.18 7.18 0 0 1 3.547.951l19.105 10.966a2.83 2.83 0 0 1 1.409 2.783h.003Z"
      fill="#12173D"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M165.135 107.817a2.809 2.809 0 0 1-1.398 2.149l-.36.211a7.944 7.944 0 0 1-7.993.01l-17.82-10.312a3.321 3.321 0 0 1-1.622-2.3 3.334 3.334 0 0 1 1.712-2.65 7.07 7.07 0 0 1 3.464-.903c1.191 0 2.446.316 3.544.95l19.108 10.966a2.801 2.801 0 0 1 1.365 1.883v-.004Z"
      fill="#fff"
      stroke="#000"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M159.005 104.316a2.809 2.809 0 0 1-1.398 2.149l-.361.21a7.94 7.94 0 0 1-7.992.01l-11.69-6.814a3.321 3.321 0 0 1-1.622-2.3 3.334 3.334 0 0 1 1.712-2.65 7.07 7.07 0 0 1 3.464-.903c1.191 0 2.446.317 3.544.95l12.975 7.469a2.805 2.805 0 0 1 1.365 1.882l.003-.003Z"
      fill="#0088FE"
    />
    <path
      d="M165.135 107.817a2.809 2.809 0 0 1-1.398 2.149l-.36.211a7.944 7.944 0 0 1-7.993.01l-17.82-10.312a3.321 3.321 0 0 1-1.622-2.3 3.334 3.334 0 0 1 1.712-2.65 7.07 7.07 0 0 1 3.464-.903c1.191 0 2.446.316 3.544.95l19.108 10.966a2.801 2.801 0 0 1 1.365 1.883v-.004Z"
      stroke="#101841"
      strokeWidth={0.334}
      strokeMiterlimit={10}
    />
    <path
      d="M159.413 95.967v9.017h-.004c-.01.697-.477 1.391-1.398 1.925-.771.444-1.745.708-2.75.785a8.644 8.644 0 0 1-1.555-.027c-.901-.104-1.765-.354-2.459-.758-.935-.54-1.402-1.248-1.402-1.955v-8.987h9.568Z"
      fill="#fff"
      stroke="#101841"
      strokeWidth={0.334}
      strokeMiterlimit={10}
    />
    <path
      d="M159.411 95.967v9.017h-.004c-.01.697-.477 1.391-1.398 1.925-.771.444-1.745.708-2.75.785V95.967h4.152Zm-4.936 0v11.747c-.38.01-.761-.007-1.138-.047v-11.7h1.138Z"
      fill="#0087FF"
    />
    <path
      d="M159.413 95.967v9.017h-.004c-.01.697-.477 1.391-1.398 1.925-.771.444-1.745.708-2.75.785a8.644 8.644 0 0 1-1.555-.027c-.901-.104-1.765-.354-2.459-.758-.935-.54-1.402-1.248-1.402-1.955v-8.987h9.568Z"
      stroke="#101841"
      strokeWidth={0.334}
      strokeMiterlimit={10}
    />
    <path
      d="M154.626 98.725c2.643 0 4.786-1.237 4.786-2.763 0-1.526-2.143-2.763-4.786-2.763s-4.785 1.237-4.785 2.763c0 1.526 2.142 2.763 4.785 2.763Z"
      fill="#101841"
      stroke="#101841"
      strokeWidth={0.334}
      strokeMiterlimit={10}
    />
    <path
      d="m32.586 29.475.017 7.763 30.349 17.197 6.007-3.478a4.102 4.102 0 0 0 2.042-3.547l-.07-32.609.701-1.138 1.025-4.668.063-1.085s-2.022-.891-2.076-.891c-.57-.37-1.588-.484-2.266-.094l-33.75 18.996a4.1 4.1 0 0 0-2.045 3.548l.003.006Z"
      fill="#0087FF"
    />
    <path
      d="m32.595 32.717.003 1.465 13.796 8.039-.044-1.488-13.755-8.016Zm.004 3.18 13.75 8.009.02.971 16.582 9.561-25.537 15.909-1.625 2.636-1.799-1.158a2.387 2.387 0 0 1-1.321-2.149l-.07-32.435v-1.344Z"
      fill="#0F6FCE"
    />
    <path
      d="m34.633 25.93 33.75-18.998c.677-.39 1.501-.167 2.265.093.054 0 2.076.891 2.076.891l-.063 1.085-1.025 4.668-.7 1.138.07 32.609a4.102 4.102 0 0 1-2.043 3.547l-6.007 3.478-25.537 15.908-1.625 2.637-1.799-1.158a2.388 2.388 0 0 1-1.321-2.15l-.07-32.434-.017-7.763c0-1.461.78-2.813 2.046-3.547v-.003Z"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m73.594 9.544.084 40.721a4.092 4.092 0 0 1-2.043 3.545L38.23 72.999c-1.605.93-3.617-.23-3.617-2.086l-.084-40.2c0-1.462.781-2.814 2.046-3.548l34.127-19.29c1.285-.744 2.893.184 2.893 1.67Z"
      fill="#fff"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m69.758 30.947-12.945-2.536c-1.325-.207-1.992.21-2.703 1.255L42.77 46.044l17.394 2.94 9.594-18.037Z"
      fill="#0087FF"
    />
    <path
      d="m69.758 30.947-12.945-2.536c-1.325-.207-1.992.21-2.703 1.255L42.77 46.044l17.394 2.94 9.594-18.037"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m67.985 26.172.057 12.107a2.81 2.81 0 0 1-1.401 2.433L47.068 52.138c-1.101.638-2.483-.156-2.483-1.431l-.056-11.663c0-1.005.533-1.933 1.404-2.433l20.07-11.583a1.323 1.323 0 0 1 1.986 1.144h-.004Z"
      fill="#fff"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M69.755 30.947v15.545a2.41 2.41 0 0 1-1.211 2.092L44.517 62.4a1.172 1.172 0 0 1-1.756-1.011L42.728 46.1l16.432-2.089L69.755 30.95v-.004Z"
      fill="#E5E7EA"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m43.43 62.451 13.06-20.36c.657-1.034 2.422-2.162 3.47-1.528l9.794 5.93s.04 1.398-1.211 2.092L44.515 62.401s-.497.34-1.084.05Z"
      fill="#fff"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M164.288 42.766v28.84a2.81 2.81 0 0 1-1.178 2.303l.01.013-2.082 1.385s-4.806-4.382-18.409-13.506l21.663-19.035h-.004Z"
      fill="#101841"
    />
    <path
      d="M164.289 35.915v6.852l-21.662 19.035c-4.078-2.736-8.22-5.513-12.087-8.11l-16.52-9.53-.33-1.75-4.465 2.814L104.679 2.3l1.168-.457c1.836-.961 2.837-.998 4.255-.207l51.464 29.568a5.437 5.437 0 0 1 2.723 4.712Z"
      fill="#0087FF"
    />
    <path d="M164.289 40.805v3.047l-6.882 4 2.547-4.538 4.335-2.51Z" fill="#0087FF" />
    <path d="M164.289 39.053v1.835l-6.882 4.005 2.547-3.33 4.335-2.51Z" fill="#101841" />
    <path
      d="M161.565 31.247 109.708 1.402c-1.338-.771-2.403-.31-3.905.357l-1.128.584 2.834 41.565 4.465-2.813 2.042 3.11 16.52 9.532 12.087 8.11c13.603 9.123 18.408 13.505 18.408 13.505l2.083-1.385-.01-.013a2.812 2.812 0 0 0 1.178-2.303V35.839c0-2.253-1.038-3.621-2.723-4.592h.006Z"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M102.843 5.406v48.791l9.595-5.547 45.67 26.789c1.896 1.094 4.265-.274 4.265-2.463V37.28a5.428 5.428 0 0 0-2.723-4.71L107.956 2.45c-2.276-1.309-5.113.333-5.113 2.956Z"
      fill="#fff"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M154.155 43.666c0 2.36-2.563 3.828-4.599 2.636l-36.96-21.135a4.094 4.094 0 0 1-2.022-3.504c-.013-2.376 2.556-3.87 4.615-2.69l36.74 20.855a4.423 4.423 0 0 1 2.223 3.838h.003Zm0 14.062c0 2.36-2.563 3.828-4.599 2.637l-36.96-21.135a4.094 4.094 0 0 1-2.022-3.504c-.013-2.376 2.556-3.871 4.615-2.69l36.74 20.855a4.423 4.423 0 0 1 2.223 3.837h.003Z"
      fill="#E5E7EA"
      stroke="#101841"
      strokeWidth={0.334}
      strokeMiterlimit={10}
    />
    <path
      d="M200.998 71.113v4.935l-15.338 10.49-6.648-3.658-4.175-2.166-2.082-22.363-2.293-3.277 1.869-.958.067-.04c1.275-.337 2.483-.42 3.4 0l22.473 12.328a5.43 5.43 0 0 1 2.724 4.709h.003Z"
      fill="#0087FF"
    />
    <path
      d="M200.996 76.049V92.52a2.823 2.823 0 0 1-1.669 2.59h-.006l-1.722 1.268-3.651-5.22-8.286-4.618 15.337-10.489-.003-.003Z"
      fill="#101841"
    />
    <path
      d="m200.998 73.637-3.564 2.306v.083l-2.233 2.783v1.245l5.797-3.37v-3.048Z"
      fill="#0087FF"
    />
    <path d="M200.998 73.637v-1.752l-5.797 3.374v1.835l5.797-3.374v-.083Z" fill="#101841" />
    <path
      d="M200.998 71.153v21.408a2.823 2.823 0 0 1-1.669 2.59h-.006l-1.856 1.222-3.521-5.176-14.934-8.277-4.508-3.334-1.749-21.198-2.293-3.277 1.869-.958.067-.04c1.148-.587 2.266-.65 3.4 0l22.473 12.328a5.43 5.43 0 0 1 2.724 4.709l.003.003Z"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M168.587 78.758c0 1.545.824 2.97 2.163 3.744l24.045 13.833c1.895 1.095 4.265-.274 4.265-2.463V72.464a5.427 5.427 0 0 0-2.724-4.71l-22.633-12.597c-2.276-1.309-5.113.333-5.113 2.956v20.645h-.003Z"
      fill="#fff"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M180.721 67.118c.307.087.614.347.784.694l1.251 2.556c.141.287.211.574.214.844.007.511-.217.951-.631 1.125l-.343.137c-.401.167-.621.584-.611 1.078.003.263.073.554.21.834l1.559 3.16c.257.524.69.895 1.131 1.018.237.067.477.06.691-.03l.343-.137c.221-.09.461-.1.705-.03.46.13.914.514 1.181 1.061l1.251 2.553c.094.184.137.38.144.564 0 .337-.14.634-.414.748-.798.33-1.685.344-2.566.097-1.669-.464-3.311-1.856-4.272-3.815l-2.596-5.3c-.514-1.04-.768-2.105-.781-3.09-.03-1.851.778-3.433 2.279-4.05a.697.697 0 0 1 .467-.02l.004.003ZM73.3 133.832l3.197-.494c.247-.037.31-.367.094-.494l-2.34-1.352a.267.267 0 0 0-.374.117l-.857 1.845a.265.265 0 0 0 .28.374v.004Zm71.752-49.256 3.197-.494a.267.267 0 0 0 .094-.494l-2.34-1.352a.266.266 0 0 0-.373.117l-.858 1.846a.265.265 0 0 0 .28.373v.004Zm18.024 4.528 1.265 2.06a.268.268 0 0 0 .377 0l1.825-1.506a.267.267 0 0 0-.19-.454l-3.09-.554a.266.266 0 0 0-.187.454ZM64.874 70.798l-.858-1.846a.265.265 0 0 0-.374-.117l-2.339 1.352a.266.266 0 0 0 .094.494l3.197.494c.21.033.37-.184.28-.374v-.003Zm71.943 2.625-.857-1.846a.265.265 0 0 0-.374-.117l-2.339 1.352a.266.266 0 0 0 .093.494l3.197.494a.264.264 0 0 0 .28-.374v-.003Z"
      fill="#0087FF"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M80.537 154.388v-2.369l-1.886.006-35.602-20.48a4.641 4.641 0 0 0-4.625 0L2.458 152.306l-1.425.006-.033 2.43h.003a2.07 2.07 0 0 0 1.045 1.762l35.835 20.678a5.69 5.69 0 0 0 5.697-.007l35.979-20.861a1.965 1.965 0 0 0 .974-1.922l.004-.004Z"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m43.052 129.115 36.506 21.001c1.321.761 1.325 2.667.006 3.431l-35.978 20.861c-2.53 1.468-3.164 1.468-5.697.007L2.05 153.737c-1.395-.804-1.395-2.82 0-3.628l36.376-20.988a4.629 4.629 0 0 1 4.626 0v-.006Z"
      fill="#fff"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.745 118.89c-4.488-2.593-8.556-2.833-11.496-1.125l-1.732 1.008c2.936-1.708 7.005-1.465 11.496 1.125 8.924 5.153 16.133 17.637 16.103 27.893-.014 5.092-1.812 8.677-4.712 10.362l1.731-1.008c2.9-1.685 4.7-5.269 4.713-10.362.03-10.252-7.179-22.74-16.102-27.893Z"
      fill="#0087FF"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.011 119.898c8.924 5.153 16.133 17.638 16.102 27.893-.03 10.252-7.285 14.39-16.205 9.238-8.924-5.153-16.133-17.641-16.103-27.893.03-10.252 7.286-14.387 16.21-9.238h-.004Z"
      fill="#fff"
      stroke="#101841"
      strokeWidth={0.334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m31.779 137.643 2.696 4.124 10.015-3.31"
      stroke="#02C902"
      strokeWidth={5.006}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default MarkOnlineImage;
